import React, { useState } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useChartToolbar } from "../../common/function/useChartToolbar";

interface Measurement {
  timestamp?: string;
  batteryLevel?: number;
}
interface BatteryChartProps {
  measurements: Measurement[];
  xAxisData: string[];
}
const BatteryChart: React.FC<BatteryChartProps> = ({ measurements,xAxisData }) => {
  const toolbar = useChartToolbar();
  const batteryData = measurements.map((m) => m.batteryLevel ?? 0);

  const options: ApexOptions = {
    chart: {
      id: "battery-chart",
      toolbar,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      categories: xAxisData,
      tickAmount: 10,
      labels: {
        style: {
          fontSize: "12px",
          colors: "#7B7484",
        },
      },
    },
    yaxis: {
      title: {
        text: "Battery Level",
        style: {
          fontSize: "12px",
          fontFamily: "Poppins",
          fontWeight: 400,
          color: "#202224",
        },
      },
      labels: {
        style: {
          fontSize: "12px",
          colors: "#7B7484",
        },
      },
      min: 0,
      max: 100,
      tickAmount: 10,
    },
    grid: {
      borderColor: "#E9E9E9",
      strokeDashArray: 2.5,
    },
    colors: ["#3B9CB9"],
    tooltip: {
      enabled: true,
      theme: "light",
    },
  };

  const series = [
    {
      name: "Battery Level",
      data: batteryData,
    },
  ];

  return (
    <div>
      <Chart options={options} series={series} type="line" height={567} />
    </div>
  );
};

export default BatteryChart;